import { Controller } from "@hotwired/stimulus"

// Gestiona el tema light/dark del admin.
// Aplica la clase "dark" en <html> y persiste la preferencia en localStorage.
//
// FA SVG convierte <i> a <svg>, por lo que no se puede cambiar el icono
// via classList. En su lugar se usan dos targets separados (moon/sun)
// que se muestran u ocultan según el tema activo.
//
// Uso en el topbar:
//   data-controller="admin--theme"
//   data-action="click->admin--theme#toggle"
//   <i class="fa-regular fa-moon" data-admin--theme-target="moon"></i>
//   <i class="fa-regular fa-sun"  data-admin--theme-target="sun"></i>
export default class extends Controller {
  static targets = ["moon", "sun"]

  static STORAGE_KEY = "admin-theme"

  connect() {
    this.#syncIcon()
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    localStorage.setItem(this.constructor.STORAGE_KEY, isDark ? "dark" : "light")
    this.#syncIcon()
  }

  #isDark() {
    return document.documentElement.classList.contains("dark")
  }

  #syncIcon() {
    if (this.#isDark()) {
      this.#hide(this.moonTarget)
      this.#show(this.sunTarget)
    } else {
      this.#show(this.moonTarget)
      this.#hide(this.sunTarget)
    }
  }

  #show(el) { el.classList.remove("hidden") }
  #hide(el) { el.classList.add("hidden") }
}
